export const setNotificationData = (data) => ({
  type: 'SET_NOTIFICATION_DATA',
  data,
});
